var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramImage14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 124,
    viewBox: "0 0 77 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4561 26.82C38.4561 18.7467 39.9028 12.4233 42.7961 7.85C45.7361 3.27666 50.5894 0.989998 57.3561 0.989998C64.1228 0.989998 68.9528 3.27666 71.8461 7.85C74.7861 12.4233 76.2561 18.7467 76.2561 26.82C76.2561 34.94 74.7861 41.31 71.8461 45.93C68.9528 50.55 64.1228 52.86 57.3561 52.86C50.5894 52.86 45.7361 50.55 42.7961 45.93C39.9028 41.31 38.4561 34.94 38.4561 26.82ZM66.5961 26.82C66.5961 23.3667 66.3628 20.4733 65.8961 18.14C65.4761 15.76 64.5894 13.8233 63.2361 12.33C61.9294 10.8367 59.9694 10.09 57.3561 10.09C54.7428 10.09 52.7594 10.8367 51.4061 12.33C50.0994 13.8233 49.2128 15.76 48.7461 18.14C48.3261 20.4733 48.1161 23.3667 48.1161 26.82C48.1161 30.3667 48.3261 33.3533 48.7461 35.78C49.1661 38.16 50.0528 40.0967 51.4061 41.59C52.7594 43.0367 54.7428 43.76 57.3561 43.76C59.9694 43.76 61.9528 43.0367 63.3061 41.59C64.6594 40.0967 65.5461 38.16 65.9661 35.78C66.3861 33.3533 66.5961 30.3667 66.5961 26.82ZM26.4063 124L18.4263 111.96L11.3563 124H0.85625L13.5263 104.54L0.71625 85.22H11.7763L19.6863 97.19L26.8263 85.22H37.3263L24.5863 104.54L37.4663 124H26.4063ZM57.1587 82V72.97H74.0287V124H63.9487V82H57.1587Z",
    fill: "#130F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6387 131H79.9787V134.5H54.6387V131Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramImage14);
export default __webpack_public_path__ + "static/media/programImage14.07c997c7d7c644c3c45d09109bd69b76.svg";
export { ForwardRef as ReactComponent };